import { render, staticRenderFns } from "./PolicyDetail.vue?vue&type=template&id=0d5600e0&scoped=true&"
import script from "./PolicyDetail.vue?vue&type=script&lang=js&"
export * from "./PolicyDetail.vue?vue&type=script&lang=js&"
import style0 from "./PolicyDetail.vue?vue&type=style&index=0&id=0d5600e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5600e0",
  null
  
)

export default component.exports